import styled from "styled-components"
import type { CSSTextAlign } from "~/types/css/rules"

export interface TableCellProps {
  fontSize?: string
  textAlign?: CSSTextAlign

  height?: string
  width?: string
  maxWidth?: string
  lineHeight?: string
  background?: string
  padding?: string
  wordBreak?: string

  onClick?: (
    event: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>,
  ) => void
}

export const TableCell = styled.td<TableCellProps>`
  box-sizing: border-box;
  border: none;
  padding: ${(props) => props.padding};
  font-size: ${(props) => props.fontSize};
  text-align: ${(props) => props.textAlign};
  line-height: ${(props) => props.lineHeight};
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  word-break: ${(props) => (props.wordBreak ? props.wordBreak : "auto")};
  cursor: ${(props) => props.onClick && "pointer"};
`

TableCell.defaultProps = {
  padding: "0 1.5rem",
  height: "60px",
  background: "#fff",
}
